import { ITranslationEntry } from '@modeso/types__aumico-lib-annualreport-be';
import { I18NextService } from 'angular-i18next';
import { GapReportingVisitor } from './GapReportingVisitor';
import { ITranslatorVisitor } from './ITranslatorVisitor.interface';
import { UntranslatedTexts } from './UntranslatedTexts';
import { AppropriationOfProfit } from './classes/AppropriationOfProfit';
export class AppropriationOfProfitTranslatorVisitor extends GapReportingVisitor implements ITranslatorVisitor {
    constructor(
        private readonly targetLanguage: string,
        private readonly reportLanguage: string,
        private i18Next: I18NextService,
        untranslated?: UntranslatedTexts,
        translations?: Record<string, ITranslationEntry>,
    ) {
        super(untranslated, 'aop', translations);
    }

    visit(appropriationOfProfit: AppropriationOfProfit): void {
        const { aop } = appropriationOfProfit;

        // Default-editable texts: unedited → the target-language default (i18next); edited → resolve
        // the custom text against the block, else keep it and report the gap.
        const isProfitCalcaulationHeaderTextEmpty = aop.profitCalculationOutput.profitCalcaulationHeaderText === '' || aop.profitCalculationOutput.profitCalcaulationHeaderText == null
        if (isProfitCalcaulationHeaderTextEmpty) {
            aop.profitCalculationOutput.profitCalcaulationHeaderText = this.getI18NextLocalizedText('aumico_annual_report_profit_calculation_header');
        } else {
            const isEdited =
                aop.profitCalculationOutput.profitCalcaulationHeaderText !==
                this.getI18NextLocalizedTextAccordingToReportLanguage('aumico_annual_report_profit_calculation_header');
            aop.profitCalculationOutput.profitCalcaulationHeaderText = this.resolve(
                aop.profitCalculationOutput.profitCalcaulationHeaderText,
                isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_profit_calculation_header'),
            );
        }

        const isAvailableRetainedEarningsTextEmpty = aop.profitCalculationOutput.availableRetainedEarningsText === '' || aop.profitCalculationOutput.availableRetainedEarningsText == null;
        if (isAvailableRetainedEarningsTextEmpty) {
            aop.profitCalculationOutput.availableRetainedEarningsText = this.getI18NextLocalizedText('aumico_annual_report_proposal_available_retained_earnings');
        } else {
            const isEdited =
                aop.profitCalculationOutput.availableRetainedEarningsText !==
                this.getI18NextLocalizedTextAccordingToReportLanguage(
                    'aumico_annual_report_proposal_available_retained_earnings',
                );
            aop.profitCalculationOutput.availableRetainedEarningsText = this.resolve(
                aop.profitCalculationOutput.availableRetainedEarningsText,
                isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_proposal_available_retained_earnings'),
            );
        }

        const isProposalDescriptionTextEmpty = aop.proposalOutput.proposalDescription === '' || aop.proposalOutput.proposalDescription == null;
        if (isProposalDescriptionTextEmpty) {
            aop.proposalOutput.proposalDescription = this.getI18NextLocalizedText('aumico_annual_report_proposal_description');
        } else {
            const isEdited =
                aop.proposalOutput.proposalDescription !==
                this.getI18NextLocalizedTextAccordingToReportLanguage('aumico_annual_report_proposal_description');
            aop.proposalOutput.proposalDescription = this.resolve(
                aop.proposalOutput.proposalDescription,
                isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_proposal_description'),
            );
        }

        const isProposalAvailableRetainedEarningTextEmpty = aop.proposalOutput.proposalAvailableRetainedEarningText === '' || aop.proposalOutput.proposalAvailableRetainedEarningText == null;
        if (isProposalAvailableRetainedEarningTextEmpty) {
            aop.proposalOutput.proposalAvailableRetainedEarningText = this.getI18NextLocalizedText('aumico_annual_report_proposal_available_retained_earnings');
        } else {
            const isEdited =
                aop.proposalOutput.proposalAvailableRetainedEarningText !==
                this.getI18NextLocalizedTextAccordingToReportLanguage(
                    'aumico_annual_report_proposal_available_retained_earnings',
                );
            aop.proposalOutput.proposalAvailableRetainedEarningText = this.resolve(
                aop.proposalOutput.proposalAvailableRetainedEarningText,
                isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_proposal_available_retained_earnings'),
            );
        }

        const isProposalCarriedForwardTextEmpty = aop.proposalOutput.proposalCarriedForwardText === '' || aop.proposalOutput.proposalCarriedForwardText == null;
        if (isProposalCarriedForwardTextEmpty) {
            aop.proposalOutput.proposalCarriedForwardText = this.getI18NextLocalizedText('aumico_annual_report_proposal_carried_forward_to_new_account');
        } else {
            const isEdited =
                aop.proposalOutput.proposalCarriedForwardText !==
                this.getI18NextLocalizedTextAccordingToReportLanguage(
                    'aumico_annual_report_proposal_carried_forward_to_new_account',
                );
            aop.proposalOutput.proposalCarriedForwardText = this.resolve(
                aop.proposalOutput.proposalCarriedForwardText,
                isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_proposal_carried_forward_to_new_account'),
            );
        }

        // ── CCR text fields ────────────────────────────────────────────────────
        if (aop.ccrOutput != null) {
            const ccr = aop.ccrOutput;

            const isCcrDescriptionEmpty = ccr.ccrDescription == null || ccr.ccrDescription === '';
            if (isCcrDescriptionEmpty) {
                ccr.ccrDescription = this.getI18NextLocalizedText('aumico_annual_report_ccr_description');
            } else {
                const isEdited = ccr.ccrDescription !== this.getI18NextLocalizedTextAccordingToReportLanguage('aumico_annual_report_ccr_description');
                ccr.ccrDescription = this.resolve(
                    ccr.ccrDescription,
                    isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_ccr_description'),
                );
            }

            const isBeginningTextEmpty = ccr.totalCapitalContributionsAtTheBeginningOfTheYearText == null || ccr.totalCapitalContributionsAtTheBeginningOfTheYearText === '';
            if (isBeginningTextEmpty) {
                ccr.totalCapitalContributionsAtTheBeginningOfTheYearText = this.getI18NextLocalizedText('aumico_annual_report_ccr_beginning_of_year');
            } else {
                const isEdited = ccr.totalCapitalContributionsAtTheBeginningOfTheYearText !== this.getI18NextLocalizedTextAccordingToReportLanguage('aumico_annual_report_ccr_beginning_of_year');
                ccr.totalCapitalContributionsAtTheBeginningOfTheYearText = this.resolve(
                    ccr.totalCapitalContributionsAtTheBeginningOfTheYearText,
                    isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_ccr_beginning_of_year'),
                );
            }

            const isEndTextEmpty = ccr.totalCapitalContributionsAtTheEndOfTheYearText == null || ccr.totalCapitalContributionsAtTheEndOfTheYearText === '';
            if (isEndTextEmpty) {
                ccr.totalCapitalContributionsAtTheEndOfTheYearText = this.getI18NextLocalizedText('aumico_annual_report_ccr_end_of_year');
            } else {
                const isEdited = ccr.totalCapitalContributionsAtTheEndOfTheYearText !== this.getI18NextLocalizedTextAccordingToReportLanguage('aumico_annual_report_ccr_end_of_year');
                ccr.totalCapitalContributionsAtTheEndOfTheYearText = this.resolve(
                    ccr.totalCapitalContributionsAtTheEndOfTheYearText,
                    isEdited ? '' : this.getI18NextLocalizedText('aumico_annual_report_ccr_end_of_year'),
                );
            }
        }

        // Bare strings without a reference — filled in place from the block, else reported as a gap.
        aop.aopDescription = this.resolve(aop.aopDescription);
        aop.profitCalculationOutput.profitLabel = this.resolve(aop.profitCalculationOutput.profitLabel);
        aop.profitCalculationOutput.customAccountName = this.resolve(aop.profitCalculationOutput.customAccountName);
        if (aop.profitCalculationOutput.account != null) {
            aop.profitCalculationOutput.account.name = this.resolve(aop.profitCalculationOutput.account.name);
        }
        aop.profitCalculationOutput.profitEntries.forEach((entry) => (entry.name = this.resolve(entry.name)));
        aop.proposalOutput.proposalEntries.forEach((entry) => (entry.name = this.resolve(entry.name)));

        if (aop.ccrOutput != null) {
            aop.ccrOutput.ccrFootnote = this.resolve(aop.ccrOutput.ccrFootnote);
            if (aop.ccrOutput.equityAccount != null) {
                aop.ccrOutput.equityAccount.name = this.resolve(aop.ccrOutput.equityAccount.name);
            }
            aop.ccrOutput.ccrEntries?.forEach((entry) => (entry.name = this.resolve(entry.name)));
        }
    }

    private getI18NextLocalizedText(key: string): string {
        return this.i18Next.t(key, {
            lng: this.targetLanguage,
        }) as string;
    }

    private getI18NextLocalizedTextAccordingToReportLanguage(key: string): string {
        return this.i18Next.t(key, {
            lng: this.reportLanguage,
        }) as string;
    }
}
